__turbopack_context__.v({
  "expanded": "PlaylistHeader-module-scss-module__MNqc1q__expanded",
  "mobile": "PlaylistHeader-module-scss-module__MNqc1q__mobile",
  "playlistHeader": "PlaylistHeader-module-scss-module__MNqc1q__playlistHeader",
  "playlistHeaderDetails": "PlaylistHeader-module-scss-module__MNqc1q__playlistHeaderDetails",
  "playlistHeaderLockIcon": "PlaylistHeader-module-scss-module__MNqc1q__playlistHeaderLockIcon",
  "playlistHeaderTitle": "PlaylistHeader-module-scss-module__MNqc1q__playlistHeaderTitle",
  "playlistHeaderUser": "PlaylistHeader-module-scss-module__MNqc1q__playlistHeaderUser",
  "playlistTooltip": "PlaylistHeader-module-scss-module__MNqc1q__playlistTooltip",
  "tiny": "PlaylistHeader-module-scss-module__MNqc1q__tiny",
});
